import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import AllPagesNavbar from "./Navbar";
import Loading from "./Loading";

const RouteMaster = () => {
  const state = useSelector((state) => state?.loginreducer);
  console.log(state);
  const [date, setDate] = useState(new Date().toISOString());
  // const username = state.emailId.split("@")[0].toUpperCase();
  const BASEURL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sclientSecret = window.sessionStorage.getItem("sclientSecret");
  const [item, setItem] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [citylist, setcitylist] = useState([]);
  const [selfrom, setSelfrom] = useState("");
  const [selto, setSelto] = useState("");
  const [newRouteId, setNewRouteId] = useState(null);
  const [daystotake, setDaysToTake] = useState(null);
  const [distance, setDistance] = useState(null);
  const [routename, setRouteName] = useState("");
  const [hourstotake, setHoursToTake] = useState("");
  const [islocal, setisLocal] = useState(false);
  const [selInterFrom, setSelInterFrom] = useState("");
  const [selInterTo, setSelInterTo] = useState("");
  const [interdistance, setInterDistance] = useState("");
  const [intermediate, setInterMediate] = useState([]);
  const [showInterMediate, setShowIntermediate] = useState(false);
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [routeend, setrouteend] = useState(false);
  const [search, setSearch] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [histintermediate, setHistIntermediate] = useState([]);
  const [hist, sethist] = useState(false);

  useEffect(() => {
    LatestRouteId();
    LoadLocation();
    FetchRoutesList();
  }, []);

  useEffect(() => {
    let totaldistance = 0;
    intermediate.forEach((item) => {
      totaldistance += parseFloat(item.InterDistance);
    });
    setDistance(totaldistance);
  }, [intermediate]);

  useEffect(() => {
    let totaldistance = 0;
    histintermediate.forEach((item) => {
      totaldistance += parseFloat(item.OM_ROUTE_DISTANCE);
    });
    setDistance(totaldistance);
  }, [histintermediate]);

  const filteredData = item.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OM_ROUTE_ID",
        "OM_ROUTE_START",
        "OM_ROUTE_END",
        "OM_ROUTE_NAME",
        "OM_ROUTE_DISTANCE",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  const LatestRouteId = () => {
    axios
      // .get(`${BASEURL}/LatestRouteId`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=474`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((response) => {
        setNewRouteId(response.data[0].NEWROUTEID);
      })
      .catch((error) => {
        console.error("Error fetching New Route Id :", error);
      });
  };

  const FetchRoutesList = () => {
    axios
      // .get(`${BASEURL_GLOBAL}/FetchRoutesList`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=652`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((response) => {
        setisloading(false);
        setItem(response.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Route details:", error);
      });
  };

  const LoadLocation = () => {
    axios
      // .get(`${BASEURL_GLOBAL}/LoadLocation`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=312`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((response) => {
        setcitylist(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Location details:", error);
      });
  };

  // Adding into table ********************************************************************************
  const handleInterMediate = (value, index) => {
    setselectedRowIndex(index);
    setInterDistance(value.InterDistance);
    setSelInterFrom(value.Interfrom);
    setSelInterTo(value.InterTo);
  };

  const handleInterMediateHist = (value, index) => {
    setSelInterFrom(
      index == 0 ? selfrom : histintermediate[index - 1].OM_ROUTE_CITY_CODE,
    );
    setSelInterTo(value.OM_ROUTE_CITY_CODE);
    setInterDistance(value.OM_ROUTE_DISTANCE);
  };

  const AddIntermediate = () => {
    if (!selInterFrom) {
      alert("kindly Supply the Intermediate From Location");
    } else if (!selInterTo) {
      alert("kindly Supply the Intermediate To Location");
    } else if (selInterFrom == selInterTo) {
      alert(
        "Intermediate From Location Cannnot be equal to Intermediate To Location",
      );
    } else if (Number(interdistance) <= 0) {
      alert("Kindly Supply Intermediate Distance greater than 0 ");
    } else {
      if (selInterTo == selto) {
        if (
          window.confirm(
            "You are reaching the end of Main Route , Do you want to continue ?",
          )
        ) {
          const newValue = {
            Interfrom: selInterFrom,
            InterTo: selInterTo,
            InterDistance: interdistance,
          };

          const existingRowIndex = intermediate.findIndex(
            (charge) =>
              charge.Interfrom === newValue.Interfrom &&
              charge.InterTo === newValue.InterTo,
          );

          if (existingRowIndex !== -1) {
            const updatedItems = [...intermediate];
            updatedItems[existingRowIndex] = newValue;
            setInterMediate(updatedItems);
          } else {
            setInterMediate([...intermediate, newValue]);
          }

          setShowIntermediate(true);
          clearAll();
        }
      } else {
        const newValue = {
          Interfrom: selInterFrom,
          InterTo: selInterTo,
          InterDistance: interdistance,
        };

        const existingRowIndex = intermediate.findIndex(
          (charge) =>
            charge.Interfrom === newValue.Interfrom &&
            charge.InterTo === newValue.InterTo,
        );

        if (existingRowIndex !== -1) {
          const updatedItems = [...intermediate];
          updatedItems[existingRowIndex] = newValue;
          setInterMediate(updatedItems);
        } else {
          setInterMediate([...intermediate, newValue]);
        }

        setShowIntermediate(true);
        clearAll();
      }
    }
  };

  const clearAll = () => {
    if (selto == selInterTo) {
      setSelInterFrom("");
      setSelInterTo("");
      setInterDistance("");
      setrouteend(true);
    } else {
      setSelInterFrom(selInterTo);
      setSelInterTo("");
      setInterDistance("");
    }
  };

  const RemoveInterMediate = () => {
    if (intermediate.length > 0) {
      const updatedValues = [...intermediate];

      if (
        selectedRowIndex !== null &&
        selectedRowIndex >= 0 &&
        selectedRowIndex < updatedValues.length
      ) {
        updatedValues.splice(selectedRowIndex, 1);
        setselectedRowIndex(null);
      } else {
        updatedValues.pop();
      }
      clearAll();
      setInterMediate(updatedValues);
      if (updatedValues.length === 0) {
        setShowIntermediate(false);
      }
    } else {
      alert("Please add Intermediate details First");
    }
  };

  const UpdateHistIntermediate = () => {
    if (!selInterFrom) {
      alert("kindly Supply the Intermediate From Location");
    } else if (!selInterTo) {
      alert("kindly Supply the Intermediate To Location");
    } else if (selInterFrom == selInterTo) {
      alert(
        "Intermediate From Location Cannnot be equal to Intermediate To Location",
      );
    } else if (Number(interdistance) <= 0) {
      alert("Kindly Supply Intermediate Distance greater than 0 ");
    } else {
      if (selInterTo == selto) {
        if (
          window.confirm(
            "You are reaching the end of Main Route , Do you want to continue ?",
          )
        ) {
          const newValue = {
            OM_ROUTE_CITY_CODE: selInterTo,
            OM_ROUTE_DISTANCE: interdistance,
          };

          const existingRowIndex = histintermediate.findIndex(
            (charge) =>
              charge.OM_ROUTE_CITY_CODE === newValue.OM_ROUTE_CITY_CODE,
          );

          if (existingRowIndex !== -1) {
            const updatedItems = [...histintermediate];
            updatedItems[existingRowIndex] = newValue;
            setHistIntermediate(updatedItems);
          } else {
            setHistIntermediate([...histintermediate, newValue]);
          }

          setShowIntermediate(true);
          clearAll();
        }
      } else {
        const newValue = {
          OM_ROUTE_CITY_CODE: selInterTo,
          OM_ROUTE_DISTANCE: interdistance,
        };

        const existingRowIndex = histintermediate.findIndex(
          (charge) => charge.OM_ROUTE_CITY_CODE === newValue.OM_ROUTE_CITY_CODE,
        );

        if (existingRowIndex !== -1) {
          const updatedItems = [...histintermediate];
          updatedItems[existingRowIndex] = newValue;
          setHistIntermediate(updatedItems);
        } else {
          setHistIntermediate([...histintermediate, newValue]);
        }

        setShowIntermediate(true);
        clearAll();
      }
    }
  };

  const RemoveInterMediateHist = () => {
    setrouteend(false);
    if (window.confirm("Are you sure you want to remove details")) {
      const updatedValues = [...histintermediate];
      const isExisting = histintermediate.some((charge) => {
        return (
          charge.OM_ROUTE_CITY_CODE ===
          updatedValues[updatedValues.length - 1].OM_ROUTE_CITY_CODE
        );
      });
      if (isExisting) {
        DeleteRouteMasterDetails(
          updatedValues[updatedValues.length - 1].OM_ROUTE_CITY_CODE,
        );
        updatedValues.pop();
      } else {
        updatedValues.pop();
      }

      setHistIntermediate(updatedValues);
      if (updatedValues.length === 0) {
        setShowIntermediate(false);
      }
    }
    clearRemove();
  };

  const clearRemove = () => {
    setSelInterFrom(
      histintermediate[histintermediate.length - 2].OM_ROUTE_CITY_CODE,
    );
    setSelInterTo("");
    setInterDistance("");
  };

  // ****************************************************************************************************
  // Saving
  async function SaveRouteMasterHeader() {
    setisloading(true);
    try {
      const response = await axios.post(
        // `${BASEURL_GLOBAL}/InsertRouteMasterHeader`,
        `${BASEURL_GLOBAL}/globalSpHandler?spname=203`,
        {
          ROUTEID: Number(newRouteId),
          ROUTESTART: selfrom,
          ROUTEEND: selto,
          ROUTEDISTANCE: Number(distance),
          CREEATEDDATE: date,
          CREATEDBY: "",
          DAYS: Number(daystotake),
          ROUTELOCAL: islocal == true ? 1 : 0,
          ROUTENAME: routename,
          ROUTEHOURS: Number(hourstotake),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sclientSecret,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Route Master Header saved successfully`);
      } else {
        console.error(`Error while saving Route Master Header`);
      }
    } catch (error) {
      console.error(`Error while saving Route Master Header`, error);
    }
  }

  async function SaveRouteMasterDetails() {
    for (let index = 0; index < intermediate.length; index++) {
      const value = intermediate[index];
      try {
        const response = await axios.post(
          // `${BASEURL_GLOBAL}/InsertRouteMasterDetails`,
          `${BASEURL_GLOBAL}/globalSpHandler?spname=202`,
          {
            ROUTEID: Number(newRouteId),
            INTERMEDIATECITYCODE: value.InterTo,
            INTERMEDIATEDISTANCE: Number(value.InterDistance),
            CREATEDBY: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sclientSecret,
            },
          },
        );

        if (response.status === 201) {
          setisloading(false);
          console.log(`Row ${index + 1} saved successfully`);
        } else {
          setisloading(false);
          console.error(`Error while saving row ${index + 1}`);
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while saving row ${index + 1}`, error);
      }
    }
  }

  async function UpdateRouteMasterDetails() {
    for (let index = 0; index < histintermediate.length; index++) {
      const value = histintermediate[index];
      try {
        const response = await axios.post(
          // `${BASEURL_GLOBAL}/InsertRouteMasterDetails`,
          `${BASEURL_GLOBAL}/globalSpHandler?spname=202`,
          {
            ROUTEID: Number(newRouteId),
            INTERMEDIATECITYCODE: value.OM_ROUTE_CITY_CODE,
            INTERMEDIATEDISTANCE: Number(value.OM_ROUTE_DISTANCE),
            CREATEDBY: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sclientSecret,
            },
          },
        );

        if (response.status === 200) {
          setisloading(false);
          console.log(`Row ${index + 1} Updated successfully`);
        } else {
          setisloading(false);
          console.error(`Error while Updating row ${index + 1}`);
        }
      } catch (error) {
        setisloading(false);
        console.error(`Error while Updating row ${index + 1}`, error);
      }
    }
  }

  async function DeleteRouteMasterDetails(value) {
    try {
      const response = await axios.post(
        // `${BASEURL_GLOBAL}/DeleteRouteMasterDetails`,
        `${BASEURL_GLOBAL}/globalSpHandler?spname=88`,
        {
          ROUTEID: Number(newRouteId),
          INTERMEDIATECITYCODE: value,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sclientSecret,
          },
        },
      );

      if (response.status === 200) {
        console.log(`Route Master Details deleted successfully`);
      } else {
        console.error(`Error while deleting Route Master Details`);
      }
    } catch (error) {
      console.error(`Error while deleting Route Master Details`, error);
    }
  }

  const handleRowClick = (value, index) => {
    sethist(true);
    setShowIntermediate(true);
    setrouteend(false);
    setNewRouteId(value.OM_ROUTE_ID);
    setSelfrom(value.OM_ROUTE_START);
    setSelto(value.OM_ROUTE_END);
    setDistance(value.OM_ROUTE_DISTANCE);
    setDaysToTake(value.OM_ROUTE_DAYS);
    setHoursToTake(value.OM_ROUTE_HOURS);
    setRouteName(value.OM_ROUTE_NAME);
    setisLocal(value.OM_ROUTE_LOCAL == 1 ? true : false);

    axios
      .get(
        // `${BASEURL_GLOBAL}/fetchRouteDetails`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=651&OM_ROUTE_ID=${value.OM_ROUTE_ID}`,
        // {
        //   routeid: Number(value.OM_ROUTE_ID),
        // },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sclientSecret,
          },
        },
      )
      .then((response) => {
        setHistIntermediate(response.data);
      })
      .catch((error) => {
        console.error("Error fetching Intermediate Route details:", error);
      });
  };

  const ClearAllInputs = () => {
    setSelfrom("");
    setSelto("");
    setDistance("");
    setDaysToTake("");
    setHoursToTake("");
    setRouteName("");
    setisLocal(false);
  };

  if (isloading) {
    return <Loading />;
  }

  return (
    <div>
      <AllPagesNavbar />

      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{"Route Master"}</h1>
      </header>
      <div className="flex justify-end gap-5 mr-3">
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={() => {
            if (selfrom || selto) {
              if (window.confirm("Are you sure you don't want to Save")) {
                window.location.reload();
              }
            } else {
              window.location.reload();
            }
          }}
        >
          New
        </button>
        <button
          className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
          onClick={async () => {
            if (!newRouteId) {
              alert("Kindly Supply Route Id");
            } else if (!selfrom) {
              alert("Kindly Supply From Location");
            } else if (!selto) {
              alert("Kindly Supply To Location");
            } else if (!routename) {
              alert("Kindly Supply Route Name");
            } else if (!distance) {
              alert("Kindly Supply Distance");
            } else if (!daystotake) {
              alert("Kindly Supply Days To Take");
            } else if (!hourstotake) {
              alert("Kindly Supply Hours To Take");
            } else {
              if (histintermediate.length > 0) {
                await SaveRouteMasterHeader();
                await UpdateRouteMasterDetails();
                alert("Saved Succesfully");
                window.location.reload();
              } else {
                await SaveRouteMasterHeader();
                await SaveRouteMasterDetails();
                alert("Saved Succesfully");
                window.location.reload();
              }
            }
          }}
        >
          Save
        </button>
      </div>

      <section className="section__Item">
        <div className="section__div">
          <div style={{ display: "flex", marginTop: "5px" }}>
            <span style={{ fontSize: "25px", color: "red" }}>Main Route</span>
          </div>

          <div className="flex gap-2">
            <p>Route Id</p>
            <input
              className="w-20 text-right pr-2 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
              type="text"
              value={newRouteId}
              readOnly
            />
            <button
              className="w-8 flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 "
              onClick={() => {
                ClearAllInputs();
                clearAll();
                setPopupOpen(true);
              }}
            >
              ...
            </button>
            &nbsp;
            {isPopupOpen && (
              <div
                style={{
                  position: "fixed",
                  top: 25,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  padding: "20px",
                  background: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    position: "fixed",
                    width: "900px",
                    height: "90vh",
                    padding: "20px",
                    background: "white",
                    borderRadius: "8px",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
                    zIndex: 1001,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                      }}
                    >
                      <p>Search :</p>&nbsp;
                      <input
                        className="h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                        type="text"
                        value={search}
                        onChange={(e) => {
                          setSearch(e.target.value);
                        }}
                      ></input>
                    </div>
                    <button
                      className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                      onClick={() => setPopupOpen(false)}
                    >
                      Close
                    </button>
                  </div>

                  <aside
                    style={{
                      overflow: "auto",
                      height: "80vh",
                      paddingTop: "10px ",
                    }}
                  >
                    <table className="custom-table  overflow__y__ relative text-[12px] ">
                      <thead className="header-cell sticky top-[0px] left-[10px]">
                        <tr>
                          <td>Route Id</td>
                          <td>From Location</td>
                          <td>To Location</td>
                          <td>Route Name</td>
                          <td>Distance</td>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.map((row, index) => (
                          <tr
                            key={index}
                            onClick={() => {
                              setPopupOpen(false);
                              handleRowClick(row, index);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <td>{row.OM_ROUTE_ID ? row.OM_ROUTE_ID : ""}</td>
                            <td>
                              {row.OM_ROUTE_START ? row.OM_ROUTE_START : ""}
                            </td>
                            <td>{row.OM_ROUTE_END ? row.OM_ROUTE_END : ""}</td>
                            <td>
                              {row.OM_ROUTE_NAME ? row.OM_ROUTE_NAME : ""}
                            </td>
                            <td>
                              {row.OM_ROUTE_DISTANCE
                                ? row.OM_ROUTE_DISTANCE
                                : 0}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </aside>
                </div>
              </div>
            )}
            <p>From Location</p>
            <Select
              className="w-64"
              onChange={(selectedOption) => {
                if (selectedOption.value === "") {
                  alert("Kinly select Proper Category");
                } else {
                  setSelfrom(selectedOption.value);
                }
              }}
              value={
                selfrom
                  ? {
                      label: selfrom,
                      value: selfrom,
                    }
                  : { label: "", value: "" }
              }
              options={[
                { value: "", label: "" },
                ...citylist.map((item) => ({
                  value: item.CITYCODE,
                  label: item.CITYCODE,
                })),
              ]}
              isDisabled={hist == true}
            />
            <p>To Location</p>
            <Select
              className="w-64"
              onChange={(selectedOption) => {
                if (selectedOption.value === "") {
                  alert("Kinly select Proper Category");
                } else if (!selfrom) {
                  alert("Kindly Supply From location first");
                } else if (selectedOption.value == selfrom) {
                  alert("To location cannot be same a From location");
                } else {
                  setSelto(selectedOption.value);
                  setSelInterTo(selectedOption.value);
                  setSelInterFrom(selfrom);
                }
              }}
              value={
                selto
                  ? {
                      label: selto,
                      value: selto,
                    }
                  : { label: "", value: "" }
              }
              options={[
                { value: "", label: "" },
                ...citylist.map((item) => ({
                  value: item.CITYCODE,
                  label: item.CITYCODE,
                })),
              ]}
              isDisabled={hist == true}
            />
          </div>
          {/* 2nd line */}
          <div className="flex lg:mt-2">
              <p>Route Name</p>
              <input
                className="h-7 lg:w-64 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="text"
                value={routename}
                onChange={(e) => {
                  setRouteName(e.target.value);
                }}
              />
              <p>Days to take</p>
              <input
                className="h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="number"
                value={daystotake}
                onChange={(e) => {
                  setDaysToTake(e.target.value);
                }}
              />
              <p>Hours to take</p>
              <input
                className="h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="number"
                value={hourstotake}
                onChange={(e) => {
                  setHoursToTake(e.target.value);
                }}
              />
              <input
                className="h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="checkbox"
                checked={islocal}
                onChange={() => {
                  setisLocal(!islocal);
                }}
              />
              <p className="lg:mr-2">Local</p>
           </div>
          <div style={{ display: "flex", marginTop: "5px" }}>
            <span style={{ fontSize: "25px", color: "red" }}>
              Intermediate Routes
            </span>
          </div>
          <div className="flex gap-3 lg:mt-2">
              <p>From Location</p>
                <Select
                  className="w-64"
                  onChange={(selectedOption) => {
                    if (selectedOption.value === "") {
                      alert("Kinly select Proper Category");
                    } else {
                      setSelInterFrom(selectedOption.value);
                    }
                  }}
                  value={
                    selInterFrom
                      ? {
                          label: selInterFrom,
                          value: selInterFrom,
                        }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...citylist.map((item) => ({
                      value: item.CITYCODE,
                      label: item.CITYCODE,
                    })),
                  ]}
                  isDisabled={routeend == true}
                />
          
              <p>To Location</p>
                <Select
                  className="w-64"
                  onChange={(selectedOption) => {
                    if (selectedOption.value === "") {
                      alert("Kinly select Proper Category");
                    } else if (selectedOption.value == selInterFrom) {
                      alert("To Location Cannot be Same as From Location");
                    } else {
                      setSelInterTo(selectedOption.value);
                    }
                  }}
                  value={
                    selInterTo
                      ? {
                          label: selInterTo,
                          value: selInterTo,
                        }
                      : { label: "", value: "" }
                  }
                  options={[
                    { value: "", label: "" },
                    ...citylist.map((item) => ({
                      value: item.CITYCODE,
                      label: item.CITYCODE,
                    })),
                  ]}
                  isDisabled={routeend == true}
                />
        
              <p>Distance</p>
              <input
                className="h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
                type="number"
                value={interdistance}
                onChange={(e) => {
                  if (!routename) {
                    alert("Kindly Provide Route name");
                    setInterDistance("");
                  } else if (!daystotake) {
                    alert("Kindly Provide days to take");
                    setInterDistance("");
                  } else if (!hourstotake) {
                    alert("Kindly Provide Hours To take");
                    setInterDistance("");
                  } else {
                    setInterDistance(e.target.value);
                  }
                }}
                disabled={routeend == true}
              />
          </div>

          <div className="flex gap-4 justify-end">
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              style={{ marginRight: "5px" }}
              onClick={() => {
                if (histintermediate.length > 0) {
                  UpdateHistIntermediate();
                } else {
                  if (routeend == true) {
                    alert("You have reached to the end of Main Route");
                  } else {
                    AddIntermediate();
                  }
                }
              }}
            >
              Add
            </button>
            <button
              className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
              onClick={() => {
                if (histintermediate.length > 0) {
                  RemoveInterMediateHist();
                } else {
                  RemoveInterMediate();
                }
              }}
            >
              Remove
            </button>
          </div>
        </div>
      </section>
      {showInterMediate && (
        <div
          className="visible "
          style={{
            height: "auto",
            width: "auto",
            padding: "4px",
            zIndex: "0",
          }}
        >
          <table className="custom-table  overflow__y__ relative text-[12px] ">
            <thead className="header-cell sticky top-[0px] left-[10px]">
              <tr >
                <td>From Location</td>
                <td>To Location</td>
                <td style={{ textAlign: "right" }}>Distance</td>
              </tr>
            </thead>
            <tbody>
              {histintermediate.length > 0
                ? histintermediate.map((value, index) => (
                    <tr
                      onClick={() => {
                        handleInterMediateHist(value, index);
                      }}
                      style={{ cursor: "pointer" }}
                      key={index}
                    >
                      <td>
                        {index == 0
                          ? selfrom
                          : histintermediate[index - 1].OM_ROUTE_CITY_CODE}
                      </td>
                      <td>
                        {value.OM_ROUTE_CITY_CODE
                          ? value.OM_ROUTE_CITY_CODE
                          : "N/A"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {value.OM_ROUTE_DISTANCE
                          ? value.OM_ROUTE_DISTANCE
                          : "N/A"}
                      </td>
                    </tr>
                  ))
                : intermediate.map((value, index) => (
                    <tr
                      onClick={() => {
                        handleInterMediate(value, index);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td>
                        {value.Interfrom ? value.Interfrom : "N/A"}
                      </td>
                      <td>
                        {value.InterTo ? value.InterTo : "N/A"}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {value.InterDistance ? value.InterDistance : "N/A"}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
          <div className="flex justify-end pr-2">
            <p>Total Distance :</p>
            <input
              className="w-28 h-7 text-right pr-2 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500"
              type="number"
              value={distance}
              readOnly
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RouteMaster;
